import { Attr, HasOne, HasMany, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Currency from "./Currency";
import Feedback from "./Feedback";
import LeagueTable from "./LeagueTable";
import JobHiringProcessTimeline from "./JobHiringProcessTimeline";
import Job from "./Job";
import { UploadFile } from "./types";

@Model()
class Employer extends ApplicationRecord {
  static jsonapiType = "employers";

  @Attr() accountManager: string;

  @Attr() accountType: string;

  @Attr() averageTimeToRespond: string;

  @Attr() canUseCustomTerms: boolean;

  @Attr() customTerms: string;

  @Attr() customTermsUrl: string;

  @Attr() employerCustomTerms: UploadFile;

  @Attr() jobVendor: string;

  @Attr() hhAverageTimeToRespond: string;

  @Attr({ persist: false }) jobsPostedPerMonthLastYear: number;

  @Attr() memberSince: string;

  @Attr() name: string;

  @Attr() hhAvgTimeToHire: string;

  @Attr() industryAvgTimeToHire: string;

  @Attr() portal: boolean;

  @Attr() premium: boolean;

  @Attr() phoneNumber: string;

  @Attr() logo: UploadFile;

  @Attr() logoUrl: string;

  @Attr() profile: string;

  @Attr() profileImage: UploadFile;

  @Attr() profileImageUrl: string;

  @Attr() employerProfileImage: UploadFile;

  @Attr() employerProfileImageUrl: string;

  @Attr() employerProfileImage2: UploadFile;

  @Attr() employerProfileImage2Url: string;

  @Attr() employerProfileImage3: UploadFile;

  @Attr() employerProfileImage3Url: string;

  @Attr() websiteAddress: string;

  @Attr() numberOfEmployees: number;

  @Attr() addressLine1: string;

  @Attr() addressLine2: string;

  @Attr() townOrCity: string;

  @Attr() postcode: string;

  @Attr({ persist: false }) twitterUrl: string;

  @Attr() twitterUsername: string;

  @Attr() facebookUrl: string;

  @Attr() linkedinUrl: string;

  @Attr({ persist: false }) instagramUrl: string;

  @Attr() instagramUsername: string;

  @Attr() glassdoorUrl: string;

  @Attr() description: string;

  @Attr() existingSince: string;

  @BelongsTo(Currency) currency: Currency;

  @HasOne(LeagueTable) leagueTable: LeagueTable;

  @HasMany(Employer) children: Employer[];

  @HasMany(Feedback) feedbacks: Feedback[];

  @HasMany(Job) jobs: Job[];

  @HasMany(JobHiringProcessTimeline)
  jobHiringProcessTimelines: JobHiringProcessTimeline;

  get isJobVendor() {
    return this.accountType === "job_vendor";
  }
}

export default Employer;
